module.exports = __webpack_public_path__ + "static/media/failure-icon.dc6b44bc.png";